// extracted by mini-css-extract-plugin
export default {"abandon_input":"Missing_abandon_input__3J8LW"};